import "shared/styles/Sidebar.css";
import React, {useCallback, useState} from "react";
import {Category} from "../types";
import CategoryComponent from "./CategoryComponent";
import {validationRulesService} from "../services/validationRulesService";
import {DataLoadingStatus} from "shared/types/common";
import {useNavigate} from "react-router-dom";

const Limit_Per_User = parseInt(process.env.REACT_APP_CAT_LIMIT_PER_USER || '10');

const CategoryList = ({activeCategory, setActiveCategory, url_cat_num}: {activeCategory: Category|undefined, setActiveCategory:  React.Dispatch<React.SetStateAction<Category | undefined>>, url_cat_num?: string}) => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [status, setStatus] = useState<DataLoadingStatus>(DataLoadingStatus.NotLoaded);

    const navigate = useNavigate();

    const comparator = useCallback((a: Category, b: Category) => a.cat_num-b.cat_num, []);

    if (status === DataLoadingStatus.NotLoaded) {
        setStatus(DataLoadingStatus.Loading);
        validationRulesService.getCategories().then(resp => {
            if (resp.errorCode === undefined) {
                setCategories(resp.curr_categories.sort(comparator));
                setStatus(DataLoadingStatus.Loaded);
            } else {
                setStatus(DataLoadingStatus.Error);
            }
        });
    }

    if (status === DataLoadingStatus.Loaded && activeCategory) {
        for (let i = 0; i < categories.length; i++) {
            if (activeCategory.cat_id === categories[i].cat_id && activeCategory.status !== categories[i].status) {
                const categories_copy = [...categories];
                categories_copy[i].status = activeCategory.status;
                setCategories(categories_copy);
                break;
            }
        }
    }

    if (status === DataLoadingStatus.Loaded && activeCategory?.cat_num?.toString() !== url_cat_num) {
        if (url_cat_num) {
            let changed = false;
            for (let i = 0; i < categories.length; i++) {
                if (url_cat_num === categories[i].cat_num.toString()) {
                    setActiveCategory(categories[i]);
                    changed = true;
                    break;
                }
            }
            if (!changed) {
                navigate('/categories');
            }
        } else {
            setActiveCategory(undefined);
        }
    }
    
    const addNewCat = () => {
        const userInput = prompt("Enter the category number:");
        if (userInput !== null) {
            const number = parseInt(userInput); 
            if (!isNaN(number)) {
                if (categories.every(cat => cat.cat_num !== number)){
                    setStatus(DataLoadingStatus.Loading);
                    validationRulesService.createCategory(number).then(resp => {
                        if (resp.errorCode !== undefined) {
                            alert(`Error: ${resp.errorCode}`);
                            setStatus(DataLoadingStatus.Error);
                        } else {
                            alert(resp.message);
                            if (resp.success) setCategories(resp.curr_categories!.sort(comparator));
                            setStatus(DataLoadingStatus.Loaded);
                        }
                    });
                } else {
                    alert("Such category already exists!");
                }
            } else { 
                alert("Please, enter a NUMBER!"); 
            }
        } else {
            alert("Can not create a category without number");
        }
    }

    const rmCategory = (cat_id: number) => {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm("Do you really want to delete this category and all its data?");
        if (confirmed) {
            validationRulesService.deleteCategory(cat_id).then(resp => {
                if (resp.errorCode !== undefined) {
                    alert(`Error: ${resp.errorCode}`);
                    setStatus(DataLoadingStatus.Error);
                } else {
                    alert(resp.success? "Successfully deleted!" : "Failed to delete category!");
                    if (resp.success) {
                        setStatus(DataLoadingStatus.Loading);
                        if (activeCategory?.cat_id === cat_id){
                            setActiveCategory(undefined);
                        }
                        validationRulesService.getCategories().then(get_resp => {
                            if (get_resp.errorCode === undefined) {
                                setCategories(get_resp.curr_categories.sort(comparator));
                                setStatus(DataLoadingStatus.Loaded);
                            } else {
                                setStatus(DataLoadingStatus.Error);
                            }
                        });
                    }
                }
            });
        }
    }
    
    return (
        <div className="category-list">
            <h3>Your categories:</h3>
            <p className="info-text-mini">{
                status === DataLoadingStatus.Error? "An error occured..." : 
                status !== DataLoadingStatus.Loaded? "Loading categories..." : 
                    categories.length === 0? "You have no categories" :
                    categories.length >= Limit_Per_User? "You have reached the limit of categories per user!" : ""
            }</p>
            <div className="scrollable categories-container-wrapper">
                <div id="categories-container">{
                    categories.map(category =>
                        <CategoryComponent
                            key={category.cat_id}
                            category={category}
                            isActive={category.cat_id === activeCategory?.cat_id}
                            setActiveCategory={setActiveCategory}
                            rmCategory={rmCategory}/>
                    )}
                </div>
            </div>
            <div>
                <button className="button green-button" disabled={status !== DataLoadingStatus.Loaded || categories.length >= Limit_Per_User} onClick={addNewCat}>Add new</button>
            </div>
        </div>
    );
};

// export default memo(CategoryList);
export default CategoryList;